<template>
    <h2>Passwort ändern</h2>
    <form @submit.prevent="onSubmit" novalidate class="mb-8">
            <base-input v-model.trim="password"
                        :id-prefix="''"
                        name="password"
                        :validations="[{ condition: v$.password.required &&  v$.password.$error && password == '' && submitted,text:'Bitte tragen Sie Ihr Passwort ein!'},{ condition: v$.password.minLength.$invalid &&  v$.password.$error && submitted,text:'Mindestlänge 6 Zeichen'}]"
                        :type="'password'" label="default.new_password" required/>
            <base-input v-model.trim="confirmPassword"
                        :id-prefix="'login'"
                        name="password_confirm"
                        :validations="[{ condition: v$.confirmPassword.$error && submitted,text:'Bitte wiederholen Sie Ihr Passwort!'}]"
                        ref="login-password"
                        :type="'password'" label="default.new_password_confirm" required/>
            <base-input v-model.trim="currentPassword"
                        :id-prefix="''"
                        name="current_password"
                        :validations="[{ condition: v$.currentPassword.required && v$.currentPassword.$error && currentPassword == '' && submitted,text:'Bitte tragen Sie Ihr Passwort ein!'}]"
                        :type="'password'" label="default.current_password" required/>
            <div class="text-right">
                <base-button type="submit" :loading="axiosCall" class="inline-block">
                    passwort speichern
                </base-button>
            </div>
    </form>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {email, minLength, required, sameAs} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance} from 'vue'
import {useStore} from "vuex";
import {API} from "@/utils/api";

export default {
    setup(props) {

        const store = useStore();
        const password = ref('');
        const confirmPassword = ref('');
        const currentPassword = ref('');
        const axiosCall = ref(false);
        const submitted = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({
            currentPassword: {
                required
            },
            password: {
                required,
                minLength: minLength(6)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs(password.value),
            }
        }))

        const v$ = useVuelidate(rules, {password, confirmPassword,currentPassword})

        const onSubmit = () => {

            submitted.value = true;
            v$.value.$touch()

            if (v$.value.$error) return;

            axiosCall.value = true

            const passwordData = {
                password: password.value,
                password_confirmation: confirmPassword.value,
                password_current: currentPassword.value,
            }

            API.post('updatePassword', passwordData).then((resp) => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                })
                submitted.value = false;
                password.value = '';
                confirmPassword.value = '';
                currentPassword.value = '';

            }).catch(err => {
                axiosCall.value = false
                submitted.value = false;
                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })

        }

        return {
            currentPassword,
            password,
            confirmPassword,
            onSubmit,
            v$,
            axiosCall,
            submitted
        }
    }
}
</script>
